import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { DataProvider } from "@/contexts/DataContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ErrorBoundary from "@/components/ErrorBoundary";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import DataPage from "@/pages/DataPage";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { installGlobalErrorHandlers } from "@/lib/errorReporting";

// Lazy load pagine pesanti (ECharts, xlsx, StoricoOperazioni)
const PlotsPage = lazy(() => import("@/pages/PlotsPage"));
const ReportPage = lazy(() => import("@/pages/ReportPage"));
const InvitePage = lazy(() => import("@/pages/InvitePage"));

function LazyFallback() {
  return (
    <div className="flex items-center justify-center py-20">
      <Loader2 className="w-6 h-6 text-fw-yellow animate-spin" />
      <span className="ml-2 text-sm text-fw-muted">Caricamento...</span>
    </div>
  );
}

function App() {
  useEffect(() => {
    installGlobalErrorHandlers();
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <DataProvider>
                    <Layout />
                  </DataProvider>
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<ErrorBoundary><DashboardPage /></ErrorBoundary>} />
              <Route path="/data" element={<ErrorBoundary><DataPage /></ErrorBoundary>} />
              <Route path="/plots" element={<ErrorBoundary><Suspense fallback={<LazyFallback />}><PlotsPage /></Suspense></ErrorBoundary>} />
              <Route path="/report" element={<ErrorBoundary><Suspense fallback={<LazyFallback />}><ReportPage /></Suspense></ErrorBoundary>} />
              <Route path="/inviti" element={<ErrorBoundary><Suspense fallback={<LazyFallback />}><InvitePage /></Suspense></ErrorBoundary>} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
